import { Link } from 'gatsby';
import React from 'react';

import styles from './ActionButton.styles';

const ActionButton = ({ href, buttonSign }) => (
  <div css={styles}>
    <Link to={href} className="btn">
      <div>{buttonSign}</div>
      <div className="arrow" />
    </Link>
  </div>
);

export default ActionButton;
